import {skipWaiting as workbox_core_skipWaiting} from 'C:/_CodigoFuentes/LD_ECOMMERCE/FUENTES_V4.4/INTERFACE/Dashboard_Ecommerce/Dashboard_Ecommerce/ClientApp/node_modules/workbox-core/skipWaiting.mjs';
import {clientsClaim as workbox_core_clientsClaim} from 'C:/_CodigoFuentes/LD_ECOMMERCE/FUENTES_V4.4/INTERFACE/Dashboard_Ecommerce/Dashboard_Ecommerce/ClientApp/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'C:/_CodigoFuentes/LD_ECOMMERCE/FUENTES_V4.4/INTERFACE/Dashboard_Ecommerce/Dashboard_Ecommerce/ClientApp/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








workbox_core_skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "./ClientApp/public/dist/0.bundle.js",
    "revision": "347c4e93754fc012c1e9840e48d52ce2"
  },
  {
    "url": "./ClientApp/public/dist/0.bundle.js.map",
    "revision": "f637f5fb41052e2a6e33b2992cf9ac63"
  },
  {
    "url": "./ClientApp/public/dist/1.bundle.js",
    "revision": "840a8cb425f775fca180e119b93630e9"
  },
  {
    "url": "./ClientApp/public/dist/1.bundle.js.map",
    "revision": "3aac3efb9b634d9529117900eee35220"
  },
  {
    "url": "./ClientApp/public/dist/2.bundle.js",
    "revision": "3b79b9c76b67b017fc9a58d7ff7defa0"
  },
  {
    "url": "./ClientApp/public/dist/2.bundle.js.map",
    "revision": "d0fcb2134b883ae11d1660f10c1ea145"
  },
  {
    "url": "./ClientApp/public/dist/5.bundle.js",
    "revision": "4c4fa26466be3189b391976f63eca4fe"
  },
  {
    "url": "./ClientApp/public/dist/5.bundle.js.map",
    "revision": "e0ae1b3c6d91d5f9655d9dd98a30cf0d"
  },
  {
    "url": "./ClientApp/public/dist/6.bundle.js",
    "revision": "93de324211e7db17aebfd1e60e960ced"
  },
  {
    "url": "./ClientApp/public/dist/6.bundle.js.map",
    "revision": "1df9b1049d36b5c8e4d43a8034558e40"
  },
  {
    "url": "./ClientApp/public/dist/7.bundle.js",
    "revision": "13eec2b9e780e37e68e7d5b589f5b52d"
  },
  {
    "url": "./ClientApp/public/dist/7.bundle.js.map",
    "revision": "132b7b5f4606391da1252b386484bac8"
  },
  {
    "url": "./ClientApp/public/dist/8.bundle.js",
    "revision": "251dba1207ec85d2b2e113c4c656683d"
  },
  {
    "url": "./ClientApp/public/dist/8.bundle.js.map",
    "revision": "74707dc784cbe6421d87301e15b582cf"
  },
  {
    "url": "./ClientApp/public/dist/9.bundle.js",
    "revision": "1657d5951c1bd965f2f3df50daa75eb1"
  },
  {
    "url": "./ClientApp/public/dist/9.bundle.js.map",
    "revision": "c380f3749509be979556b5a254d4c0bf"
  },
  {
    "url": "./ClientApp/public/dist/app.bundle.js",
    "revision": "3805c39513d1c17692bf706e7f4357d6"
  },
  {
    "url": "./ClientApp/public/dist/app.bundle.js.map",
    "revision": "9fbbc73cd27f082871a1ecd303bb7119"
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.bundle.js",
    "revision": "2e4a6ab39d74c9a4d432fad627f5d055"
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.bundle.js.map",
    "revision": "38797de79763d76e9b3003033fce5ed7"
  }
], {});








